import discardSurfaceActionsOption from './actions/discardSurfaceActionsOption';
import saveSurfaceActionsOption from './actions/saveSurfaceActionsOption';
import MailSurfaceActions from './components/MailSurfaceActions';
import isSurfaceActionsOptionDirty from './utils/isSurfaceActionsOptionDirty';
import * as React from 'react';
import './orchestration/pinDarkModeToggleAction'; // Imported so code gets consumed.
var ReadSurfaceActionsOption = {
    key: 'readSurfaceActions',
    titleStringKey: 'optionTitle_readSurfaceActions',
    searchTermsStringKey: 'optionTitle_readSurfaceActions',
    fullOptionFormSettings: {
        render: function () { return React.createElement(MailSurfaceActions, { isCompose: false }); },
        isDirty: isSurfaceActionsOptionDirty,
        onSave: saveSurfaceActionsOption,
        onDiscard: discardSurfaceActionsOption,
    },
};
export default ReadSurfaceActionsOption;
//# sourceMappingURL=ReadSurfaceActionsOption.js.map